import { CURRENCIES, EURO_COUNTRY_NAVIGATOR_LANGUAGES } from '@/constants'

export function getBrowserCurrency(): CURRENCIES {
  let currency = CURRENCIES.USD

  if (navigator.language) {
    const lang = navigator.language
    const isEuroCountry: boolean = EURO_COUNTRY_NAVIGATOR_LANGUAGES.some(x => lang === x.toLowerCase() || lang.split('-').slice(-1)[0] === x)

    if (lang === 'en') {
      currency = CURRENCIES.GBP
    } else if (isEuroCountry) {
      currency = CURRENCIES.EUR
    }
  }

  return currency
}
